import TotalSpent from "views/admin/default/components/TotalSpent";
import PieChartCard from "views/admin/default/components/PieChartCard";
import Widgets from "views/admin/default/components/Widgets";
import CheckTable from "views/admin/default/components/CheckTable";
import ComplexTable from "views/admin/default/components/ComplexTable";
import PlansDistributionWidget from "views/admin/default/components/PlansDistributionWidget";
import TopInstitutionsWidget from "views/admin/default/components/TopInstitutionsWidget";
import PostulationsBreakdownChart from "views/admin/default/components/PostulationsBreakdownChart";
import ProvincesChart from "views/admin/default/components/ProvincesChart";
import InstitutionsComparisonWidget from "views/admin/default/components/InstitutionsComparisonWidget";
import NewRegistrationsChart from "views/admin/default/components/NewRegistrationsChart";
import PostulationsMonthlyChart from "views/admin/default/components/PostulationsMonthlyChart";
import TopInstitutionsByApplicationsTable from "views/admin/default/components/TopInstitutionsByApplicationsTable";
import TopPostulantesTable from "views/admin/default/components/TopPostulantesTable";
import TopPublicacionesTable from "views/admin/default/components/TopPublicacionesTable";
import PublicacionesEstadoChart from "views/admin/default/components/PublicacionesEstadoChart";
import SegmentacionActividadChart from "views/admin/default/components/SegmentacionActividadChart";
import SectionTitle from "components/sectionTitle";

const Dashboard = () => {
  return (
    <div className="flex flex-col gap-10">
      <section>
        <SectionTitle eyebrow="Ahora mismo">Resumen</SectionTitle>
        <Widgets />
      </section>

      <section className="rounded-[20px] bg-lightPrimary/60 py-5 dark:bg-navy-900/60">
        <SectionTitle eyebrow="Lo que necesita tu atención">Pulso del negocio</SectionTitle>
        <div className="grid grid-cols-1 gap-5 xl:grid-cols-3 items-start">
          <TopInstitutionsWidget />
          <PlansDistributionWidget />
          <InstitutionsComparisonWidget />
        </div>
      </section>

      <section>
        <SectionTitle eyebrow="Historia y contexto">Tendencias y detalle</SectionTitle>

        <div className="flex flex-col gap-5">
          <div className="grid grid-cols-1 gap-5 xl:grid-cols-3 items-start">
            <TotalSpent />
            <NewRegistrationsChart />
            <PostulationsMonthlyChart />
          </div>

          <div className="grid grid-cols-1 gap-5 xl:grid-cols-3 items-start">
            <ProvincesChart />
            <PieChartCard />
            <PostulationsBreakdownChart />
          </div>

          <TopInstitutionsByApplicationsTable />

          <ComplexTable />

          <CheckTable />
        </div>
      </section>

      <section>
        <SectionTitle eyebrow="Quién postula y qué se busca">Actividad y demanda</SectionTitle>

        <div className="flex flex-col gap-5">
          <div className="grid grid-cols-1 gap-5 xl:grid-cols-2 items-start">
            <TopPostulantesTable />
            <TopPublicacionesTable />
          </div>

          <div className="grid grid-cols-1 gap-5 xl:grid-cols-2 items-start">
            <PublicacionesEstadoChart />
            <SegmentacionActividadChart />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Dashboard;
